// export class ActivoFijoModel {

//     constructor(
//         public idActivo: string,
//         public tipoIdFuncionario: string,
//         public numeroIdFuncionario: string,
//         public tipo: string,
//         public serialActivoFijo: string,
//         public descripcion: string,
//         public estado: string,
//         public clasificacion: string,
//         public cual: string,
//         public marca: string,
//         public placaInventario: string,
//         public autorizadoPor: string,
//         public observaciones: string,
//         public perteneceA: string,
//         public icono?: string,
//         public activoPropio?: boolean,
//         public seleccionado?: boolean) {
//     }
// }

export class ActivoFijoModel {

  constructor(
    public idActivo: any,
    public tipoIdFuncionario: string,
    public numeroIdFuncionario: string,
    public tipo: string,
    public serialActivoFijo: string,
    public descripcion: string,
    public estado: any,
    public clasificacion: string,
    public cual: string,
    public marca: string,
    public placaInventario: string,
    public autorizadoPor: string,
    public observaciones: string,
    public perteneceA: string,
    public icono?: string,
    public activoPropio?: boolean,
    public seleccionado?: boolean,
    public numeroIngresos?: any,
    public fechaUltimoIngreso?: any,
    public pantallaOrigen?: any,
    public sede?: any,
    public tipoActivoFijo?: string,
    public marcaActivoFijo?: string,
    public descripcionActivoFijo?: string,
    public estadoActivoFijo?: string,
    public idRegIngSalActivoFijo?: number,
    public idActivoFijo?: number,
    public tipoDocumentoFuncionario?: string,
    public numeroDocumentoFuncionario?: string,
    public fechaUltimaSalida?: Date,) {
  }
}
